import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { usersProfile_template } from "../components/templates/usersProfile_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

enum ChartPanels {
    CUMULATIVE_EARNING = 'cumulativeEarning',
    TOP_FIVE_ARTICLES = 'topFiveArticles',
    DAILY_PAYMENT = 'dailyPayment',
}

export class users_profile extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: usersProfile_template;
    protected validationsList: validationsList_template;
    protected articlePerformanceTimer;

    protected getModuleName(){
        return "users_profile";
    }

    buildContent() : Array<Element>{

        // create the users form
        this.editForm = new usersProfile_template("userProfile", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("User Profile");
        return [ this.editForm.build()];
    }

    fillPage() : void{
        this.editForm.articlePerformance.buildDatePickerCalendar();

        this.getFormData();
    }


    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData(){

        this.loadingIn(this.editForm.builtTemplate);

        let idUser: number;

        idUser = this.getVnAppZone().app.params.id;

        let subViewModel = {
            idUser: idUser
        };

        this.editForm.getTemplateViewModel().loggedUser(this.getUser())

        let loggedUserRoles = this.getUser().user.valnet_user.roles.map(r => r.name)

        this.editForm.getTemplateViewModel().loggedUserRoles(loggedUserRoles)

        let usrReq_url: string = '/api/user/profile/references/get/' + idUser + '/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }


    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                obj.editForm.articlePerformance.setBrands(data.brands);
                obj.editForm.articlePerformance.setBrandsFilterItems(data.user.brands);
                obj.editForm.articlePerformance.setSelectedBrand(data.latestUserActiveBrand);
                obj.editForm.articlePerformance.setPageTypesFilterItems(data.pageTypes);
                obj.editForm.articlePerformance.setContentTypesFilterItems(data.contentTypes);
                obj.editForm.articlePerformance.setNetworkCategoriesFilterItems(data.networkCategories);
                obj.editForm.payment.setBrandFilter(data.user.brands, data.user.company);
                obj.editForm.payment.setBrands(data.brands);
                obj.editForm.payment.setPaymentPeriods(data.periods);
                obj.editForm.rates.setBrands(data.user.brands);
                obj.editForm.setPermissions(data.userPermissions)

                obj.loadingOut(obj.editForm.builtTemplate);

                obj.getUserData();

            });
        }
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getUserData(){


        let queryParam = window.location.href.split('?');
        if (queryParam.length > 1) {
            let tabQueryParam = queryParam[1]
            let tabQueryArray = tabQueryParam.split('=');
            if (tabQueryArray[1] == "payment") {
                this.getUserPaymentData();
                return;
            }
        }
        this.getArticlePerformanceData();

    }

    public getArticlePerformanceData() {

        this.editForm.articlePerformance.setVisible(true);
        this.editForm.rates.setVisible(false);
        this.editForm.payment.setVisible(false);

        this.loadingIn(this.editForm.builtTemplate);

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let idUser: number;

        idUser = this.getVnAppZone().app.params.id;
        let subViewModel = {
            idUser: idUser
        };

        let usrReq_url: string = '/api/user/profile/get/' + idUser + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUserDataReturn;
        this.XHRHdl.execute();
    }

    //
    // use the form data to fill the form
    protected onGetUserDataReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                let user = data.user;

                if(user !== undefined){
                    obj.editForm.setUser(user);
                }

                obj.editForm.setPermissions(data.userPermissions);
                obj.editForm.setCompany(data.company);

                obj.loadingOut(obj.editForm.builtTemplate);
                if(data.user.brands.length >0){
                    obj.getUserArticlePerformanceData();

                }
                obj.editForm.internalNote.setApplicationHistory(data.applicationHistory);
                obj.editForm.internalNote.setOffboardingHistory(data.offboardingHistory);
                obj.getUserActiveSessionsPerformanceData();
            });
        }
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getUserRateData(){

        this.editForm.rates.setVisible(true);
        this.editForm.articlePerformance.setVisible(false);
        this.editForm.payment.setVisible(false);

        this.editForm.rates.isLoading(1);
        this.editForm.isLoading(1);

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        let idUser: number;

        idUser = this.getVnAppZone().app.params.id;

        let subViewModel =  {...{idUser: idUser}, ...this.editForm.rates.getViewModelForRequest()};

        let usrReq_url: string = '/api/user/rate/get/' + idUser + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUserRateDataReturn;
        this.XHRHdl.execute();
    }


    //
    // use the form data to fill the form
    protected onGetUserRateDataReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                obj.editForm.rates.setUserRates(data.userRates);
                obj.editForm.rates.setHasData(true);
                obj.editForm.rates.isLoading(0);

                obj.editForm.isLoading(0);
            });
        }
    }

    // obtain the dynamic data required to fill the formulary
    protected getUserActiveSessionsPerformanceData(){

        this.editForm.articlePerformance.setVisible(true);
        this.editForm.payment.setVisible(false);
        this.editForm.rates.setVisible(false);

        this.editForm.articlePerformance.isLoadingPerformance(1);

        let idUser: number;
        idUser = this.getVnAppZone().app.params.id;

        let role = this.editForm.getTemplateViewModel().articlePerformanceRole();

        let subViewModel =  {...{idUser: idUser, role: role }, ...this.editForm.articlePerformance.getViewModelForRequest()};

        let usrReq_url: string = '/api/user/activeSessionsPerformance/get/' + idUser + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUserActiveSessionsPerformanceData
        this.XHRHdl.execute();
    }

    //
    // use the form data to fill the form
    protected onGetUserActiveSessionsPerformanceData(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                let authorPerformance = data.authorPerformance;
                let userPicture = data.userPicture;

                obj.editForm.articlePerformance.setUserPicture(userPicture);
                obj.editForm.articlePerformance.setAuthorPerformance(authorPerformance);
                obj.editForm.articlePerformance.setDailyViews(data.dailyViews);
                obj.editForm.articlePerformance.setRoleTitle(data.roleTitle ? data.roleTitle : '');
                obj.editForm.showDailyViewsChart();
                obj.editForm.articlePerformance.isLoadingPerformance(0);
            });
        }
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getUserArticlePerformanceData(){
        this.editForm.articlePerformance.setVisible(true);
        this.editForm.articlePerformance.isLoading(1);
        this.editForm.payment.setVisible(false);
        this.editForm.rates.setVisible(false);

        this.editForm.articlePerformance.isLoading(1);

        let idUser: number;

        idUser = this.getVnAppZone().app.params.id;

        let role = this.editForm.getTemplateViewModel().articlePerformanceRole();
        let subViewModel =  {...{idUser: idUser, role: role}, ...this.editForm.articlePerformance.getViewModelForRequest()};

        let usrReq_url: string = '/api/user/articlePerformance/get/' + idUser + "/";

        this.articlePerformanceTimer = new Date().getTime();
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUserArticlePerformanceData;
        this.XHRHdl.execute();
    }

    //
    // use the form data to fill the form
    protected onGetUserArticlePerformanceData(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                let nonScheduledPerformance = [];

                for(let item of data.userArticlesPerformance.data.performance){
                    if(item.daysCompletion >= 0){
                        nonScheduledPerformance.push(item);
                    }
                }

                obj.editForm.articlePerformance.setIdBrand(data.userArticlesPerformance.data.idBrand);
                obj.editForm.articlePerformance.setTotalRow(data.userArticlesPerformance.data.total);
                obj.editForm.articlePerformance.setArticlePerformance(nonScheduledPerformance);
                obj.editForm.articlePerformance.pagination.getTemplateViewModel().itemCount(data.userArticlesPerformance.totalCount);
                obj.editForm.articlePerformance.setHasData(true);
                obj.editForm.articlePerformance.isLoading(0);

                let execTime = Math.round((new Date().getTime() - obj.articlePerformanceTimer)/1000*100)/100;
                obj.editForm.articlePerformance.setResultInfo(data.userArticlesPerformance.totalCount, data.userArticlesPerformance.totalPage, execTime);

                obj.editForm.isLoading(0);
            });
        }
    }

    protected getUserPaymentData(){

        this.editForm.payment.setVisible(true);

        this.editForm.payment.isLoading(1);
        this.editForm.isLoading(1);

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        let idUser: number;

        idUser = this.getVnAppZone().app.params.id;
        let subViewModel =  {...{idUser: idUser}, ...this.editForm.payment.getViewModelForRequest()};
        let usrReq_url: string = '/api/user/payment/get/' + idUser + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUserPaymentData;
        this.XHRHdl.execute();
    }

    protected onGetUserPaymentData(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                let user = data.user;
                if(user !== undefined){
                    obj.editForm.setUser(user);

                    let currency = user.valnet_paymentInfo.currency;
                    obj.editForm.payment.setCurrency(currency);

                }

                obj.editForm.setPermissions(data.userPermissions);
                obj.editForm.payment.setNextPayDate(data.nextPayDate);
                obj.editForm.payment.setSlips(data.slips.data);
                obj.editForm.payment.setYearSelector(data.slips.years);
                obj.editForm.payment.setYearSelectorSelectedOption(data.slips.idYear);
                obj.editForm.payment.setTransactions(data.transactions);
                obj.editForm.payment.transactionsPagination.getTemplateViewModel().itemCount(data.totalTransactions);
                obj.editForm.payment.setTransactionsTotalAmount(data.totalEarnings);
                obj.editForm.payment.setShowTotal(data.showTotal);
                obj.editForm.payment.setHasData(true);
                obj.editForm.payment.isLoading(0);


                obj.editForm.isLoading(0);
            });
        }
    }

    private handleTabToShow(): void {

        this.editForm.articlePerformance.setVisible(false);
        this.editForm.rates.setVisible(false);
        this.editForm.payment.setVisible(true);
    }

    protected getData(source, resetPagination) {
        switch (source) {
            case 'authorPerformanceAndArticlePerformance': {
                if(Object.keys(this.viewModel.userProfile.articlePerformance.brands()).length != 0){

                // authorPerformance
                this.getUserActiveSessionsPerformanceData();

                // articlePerformance
                if (resetPagination) {

                    this.viewModel.userProfile.articlePerformance.articlePerformance_pagination.pageNumber(1);
                }
                this.getUserArticlePerformanceData();
                }
                break;
            }
            case 'articlePerformance': {
                if(Object.keys(this.viewModel.userProfile.articlePerformance.brands()).length != 0){
                    if (resetPagination) {

                        this.viewModel.userProfile.articlePerformance.articlePerformance_pagination.pageNumber(1);
                    }
                    this.getUserArticlePerformanceData();
                }
                break;
            }
            case 'rates': {

                this.getUserRateData();
                break;
            }
            case 'transactions': {

                if (resetPagination) {

                    this.viewModel.userProfile.payment.transactions_pagination.pageNumber(1);
                }
                this.getUserPaymentData();
                break;
            }
            case 'slips': {

                this.getUserPaymentData();
                break;
            }
            case 'payment': {

                this.getUserPaymentData();
                break;
            }

            default: {
                console.log('invalid source');
            }
        }
    }

    protected authorPerformanceListReorder(){

        this.getData("authorPerformance", true);
    }


    protected articlePerformanceListReorder(){

        this.getData("articlePerformance", true);
    }

    protected transactionListReorder(){

        this.getData("transactions", true);
    }

    protected slipListReorder(){

        this.getData("slips", true);
    }

    protected paginationOnPageClick(idElement) {

        this.getData(idElement.substr(0, idElement.indexOf('_')), false);
    }

    protected filterMultipleSelectorOnChange(idElement) {

        this.getData(idElement.substr(0, idElement.indexOf('_')), true);
    }

    protected filterDateOnChange(idElement) {

        this.getData(idElement.substr(0, idElement.indexOf('_')), true);
    }

    protected filterSimpleOnChange(idElement) {

        this.getData(idElement.substr(0, idElement.indexOf('_')), true);
    }

    protected filterDropdownOnChange(idElement) {

        this.getData(idElement.substr(0, idElement.indexOf('_')), true);
    }

    protected onShowAllPending() {

        this.getData("transactions", true);
    }



    protected editUser(){

        page.redirect('/users/edit/' + this.getVnAppZone().app.params.id)
    }

    protected editUserRates(){

        this.getVnAppZone().addGlobal({index: "userEditTab", value: 'rates'});
        page.redirect('/users/edit/' + this.getVnAppZone().app.params.id)
    }

    protected usersList(){

        page.redirect('/users')
    }

    protected cancelEditUser(){

        this.releaseLock();

        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "User action canceled !");
        let saved_viewModel = this.getVnAppZone().getGlobal("earnings_viewModel");
        if(saved_viewModel){
            page.redirect('/payment/earnings');
        }
        else{
            page.redirect('/users');
        }
    }

    protected releaseLock(){
        // request a lock release
        let usrReq_url: string = '/api/user/release/lock/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        // usrReq_params.push(["data", this.getVnAppZone().app.params.id] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }

    protected showCountryMessage(){
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Contact your system administrator to edit your country");
        this.getVnAppZone().showNotificationToModule();
    }

    protected updateElementForm(user, thisModule: users_profile){

        thisModule.viewModel["userProfile"].id(user.id);
        thisModule.viewModel["userProfile"].user(user);
        if (user.id != null){
            //if user already exists (not new)
            let vnApp = this.getVnAppZone().app;
            let userRoles: Array<number> = vnApp.loggedUser.user.valnet_user.roles;
            let idUser = vnApp.loggedUser.user.id;

            thisModule.viewModel["userProfile"].isPayPalCheckboxVisible(false);
            if((userRoles.indexOf(3) > -1 || userRoles.indexOf(2) > -1) && userRoles.indexOf(1) < 0 && idUser != user.id) {
                //disable PayPal ID if user is a QA or CM
                this.viewModel["userProfile"].isPaymentEmailDisabled(true);
            }
        }

        let isActive:string = (user.isActive != null) ? (user.isActive).toString() : "1";
        thisModule.viewModel["userProfile"].isActive(isActive);
    }

    protected viewSlip(idUser, paymentDate){

        page('/payment/documents/slip/'+ idUser + '?datePaid=' + paymentDate);
    }

    protected getArticlesSuggestion(keyword) {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/user/' + this.getVnAppZone().app.params.id + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.articles) {
                        obj.editForm.articlePerformance.setArticlesFilter(responseParsed.data.articles);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.editForm.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.editForm.deactivateLoading();
            }
        }
    }

    public getFullName(): string {
        return this.editForm.getFullName();
    }

}



// WEBPACK FOOTER //
// ./js/modules/users_profile.ts